import { combineReducers } from "redux";
import getAll from "./get-all";
import getOne from "./get-one";
import editOne from "./update";
import newOne from "./new";

const user = combineReducers({
  getAll,
  getOne,
  editOne,
  new: newOne,
});

export default user;
